import {combineReducers} from 'redux';
import loginReducer from './reducers/login.reducer';
import cartReducer from './reducers/cart.reducer'
import productReducer from './reducers/product.reducer'

export default combineReducers({
    loginReducer,
    cartReducer,
    productReducer
});